<ngx-spinner
  bdColor="rgba(255,255,255,0.5)"
  size="medium"
  color="#07b59a"
  type="ball-spin-clockwise"
  [fullScreen]="true"></ngx-spinner>
<router-outlet></router-outlet>
